import styled from 'styled-components';

export const Container = styled.button`
  font-family: 'Roboto';
  font-size: 12px;
  font-weight: 400;

  background-color: #ff6900;
  border-radius: 50px;
  height: 50px;
  width: 50px;

  justify-content: center;
`;
